var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgUndoEnabled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 7.72H3.77l2.15-2.15a.61.61 0 0 0 0-.85.61.61 0 0 0-.85 0L2.33 7.47l-.25.25-.35.35-.25.25.25.24.35.36.25.24 2.74 2.75a.59.59 0 0 0 .85 0 .61.61 0 0 0 0-.85L3.77 8.92H13a.6.6 0 0 0 .6-.6.6.6 0 0 0-.6-.6Z",
  "data-name": "Ebene 1"
})));

export default SvgUndoEnabled;